import { Gestacao } from 'graphql/types.generated'
import moment, { Moment } from 'moment'

export function filterGestacoesPeriodo(gestacoes: Gestacao[], init: Moment, end: Moment) {
  return gestacoes.filter((g) => moment(g.inicio).isBefore(end) && getFim(g.inicio, g.fim).isAfter(init))
}

const getFim = (inicio: any, fim: any) => (fim ? moment(fim) : moment(inicio).add(42, 'weeks'))
